import { ContentPage, TermsOfServicePage } from '@front-activerse/modules';
import { Route } from '../Routing/types';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
    private: false,
    title: dummy_t('termsOfService.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/privacy-policy',
    element: <ContentPage />,
    private: false,
    title: dummy_t('privacyPolicy.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/payment-info',
    element: <ContentPage />,
    private: false,
    title: dummy_t('paymentInformation.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/terms-of-service-android',
    element: <ContentPage />,
    private: false,
    title: dummy_t('termsOfService.android'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/terms-of-service-ios',
    element: <ContentPage />,
    private: false,
    title: dummy_t('termsOfService.ios'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/terms-of-service-web',
    element: <ContentPage />,
    private: false,
    title: dummy_t('termsOfService.web'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/how-to',
    element: <ContentPage />,
    private: false,
    title: dummy_t('accessToServiceAndPayments.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/info',
    element: <ContentPage />,
    private: false,
    title: dummy_t('info.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
];

export default routes;
